import React, { useState, Suspense, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Outlet,
} from "react-router-dom";
import Preloader from "../Components/Preloader";
import Home from "../pages/Home";
import { createBrowserHistory } from "history";

const history = createBrowserHistory();

const RoutesRelogio = () => {
  useEffect(() => {
    if (window.location.protocol == "http:") {
      console.log(
        "you are accessing us via " +
          "an insecure protocol (HTTP). " +
          "Redirecting you to HTTPS."
      );
      window.location.href = window.location.href.replace("http:", "https:");
    } else if (window.location.protocol == "https:") {
      console.log("you are accessing us via" + " our secure HTTPS protocol.");
    }
  }, []);
  return (
    <>
      <Suspense fallback={<Preloader />}>
        <Router history={history} basename="/relogio">
          <Routes>
            <Route path="/" element={<Home />} />
            {/* <Route path="/seletordemodelos" element={<SeletorDeModelos />} />
            <Route path="/assistentevirtual" element={<AssistenteVirtual />} />
            <Route
              path="/mapaconcessionarias"
              element={<MapaConcessionarias />}
            />
            <Route path="/configurador" element={<Configurador />} /> */}
          </Routes>
        </Router>
      </Suspense>
    </>
  );
};

export default RoutesRelogio;
